import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RedirectPopupStore {

}

export enum RedirectPopupStoreKeys {

}
